import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SaveDialog } from 'ui-toolkit';

interface IBlockRedirectionProps {
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  isDirty: boolean;
  saveChanges?: () => Promise<any>;
}

export const BlockRedirection: React.FC<IBlockRedirectionProps> = ({
  showSaveSpinner,
  showSaveSuccess,
  isDirty,
  saveChanges,
}) => {
  const [showSaveDialog, setShowSaveDialog] = useState<boolean>(false);
  const [blockedPath, setBlockedPath] = useState<string>('');
  const history = useHistory();
  const unblockHandle = useRef<any>();

  useEffect(() => {
    unblockHandle.current = history.block((location) => {
      if (isDirty) {
        setShowSaveDialog(true);
        setBlockedPath(location.pathname);
        return false;
      } else {
        return unblockHandle.current();
      }
    });
    return () => {
      unblockHandle.current.current && unblockHandle.current.current();
    };
  }, [history, isDirty]);

  // block outside navigation (Rails page)
  useEffect(() => {
    const onClick = (e: Event) => {
      const origin = (e as any).target.closest(`a`);
      if (origin && isDirty && !origin.href.includes('/spa')) {
        setBlockedPath(origin.href);
        setShowSaveDialog(true);
        e.preventDefault();
      }
    };
    window.addEventListener('click', onClick);

    return () => {
      window.removeEventListener('click', onClick);
    };
  });

  const onNoClick = () => {
    setShowSaveDialog(false);
    if (blockedPath.includes('/spa')) {
      if (unblockHandle) {
        unblockHandle.current();
      }
      history.push(blockedPath);
    } else {
      window.location.href = blockedPath;
    }
  };

  const onYesClick = async () => {
    if (saveChanges) {
      try {
        await saveChanges();
        onNoClick();
      } catch (e) {}
    } else {
      setBlockedPath('');
      setShowSaveDialog(false);
    }
  };

  return (
    <>
      {showSaveDialog && (
        <SaveDialog
          onYesClick={onYesClick}
          onNoClick={onNoClick}
          showSaveSuccess={showSaveSuccess}
          showSaveSpinner={showSaveSpinner}
        />
      )}
    </>
  );
};
